var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('unattended'),_c('v-divider',{staticClass:"mb-8 mx-lg-6 d-md-block d-none"}),_c('devices')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }